import React from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useOnboardingGate } from "../OnBoardingScreen/use-onboarding-gate";
import { isOnboardingScan } from "../OnBoardingScreen/session-keys";
import { canAccessDashboard } from "../OnBoardingScreen/user-access";

// App routes (/ , /dashboard, /payments, …). Signed-in users without
// has_delivered_order or has_datum_asset never enter the app — mid-scan or not.
const AuthGuard = ({ children }) => {
  const auth = useSelector((state) => state?.session);
  const path = window.location.pathname;
  const paymentPath =
    path !== "/PaymentSuccess" && path !== "/PaymentFailed";

  const midOnboarding = isOnboardingScan();
  const needsResume =
    Boolean(auth?.auth) &&
    !auth?.isLoading &&
    !canAccessDashboard() &&
    !midOnboarding;

  const { ready, redirectTo: destination } = useOnboardingGate({
    authed: auth?.auth,
    loading: auth?.isLoading,
    needsServerStatus: needsResume,
  });

  if (!auth.auth && paymentPath) {
    return <Redirect to="/onboarding" />;
  }

  if (auth.auth && !auth.isLoading && !canAccessDashboard()) {
    if (midOnboarding) {
      return <Redirect to="/onboarding" />;
    }
    if (!ready || !destination) {
      return null;
    }
    return <Redirect to={destination} />;
  }

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export default AuthGuard;
